import { CREATE_CANCELLATION } from '../../constants/actions/policy';

export function createCancellation(payload) {
    return {
        type: CREATE_CANCELLATION,
        payload,
    };
}
